import React from 'react';

function Experience() {
    return (
        <section id="experience" className="py-32 bg-black relative">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">

                <div className="flex flex-col md:flex-row justify-between items-end gap-10 mb-20 animate-fade-in-up">
                    <div className="space-y-4">
                        <h2 className="text-green-500 font-black tracking-widest text-sm uppercase">Background</h2>
                        <h3 className="text-5xl md:text-7xl font-black text-white leading-none uppercase tracking-tighter">Career <br /><span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-400 to-gray-600">Timeline.</span></h3>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
                    {/* Experience Column */}
                    <div className="space-y-12">
                        <div className="flex items-center gap-6 mb-4">
                            <div className="w-14 h-14 bg-green-500 rounded-2xl flex items-center justify-center text-black shadow-[0_0_15px_rgba(71,232,2,0.3)]">
                                <i className="bi bi-briefcase-fill text-2xl"></i>
                            </div>
                            <h4 className="text-2xl font-black text-white uppercase tracking-tighter">Experience</h4>
                        </div>

                        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-6 before:h-full before:w-[2px] before:bg-white/5">
                            {/* IT Specialist */}
                            <div className="relative pl-16 group">
                                <div className="absolute left-4 top-2 w-4 h-4 rounded-full bg-green-500 border-4 border-black z-10 group-hover:scale-150 transition-transform duration-300"></div>
                                <div className="glass-card p-10 rounded-[2rem] hover:border-green-500/30 transition-all duration-500">
                                    <span className="text-green-500 font-black text-xs uppercase tracking-widest">Ongoing</span>
                                    <h4 className="text-2xl font-black text-white mt-1 uppercase tracking-tighter">IT Specialist</h4>
                                    <p className="text-gray-500 font-bold mb-6">In-House Solutions</p>
                                    <p className="text-gray-400 text-lg leading-relaxed">
                                        Orchestrating robust digital infrastructures, managing network ecosystems, and ensuring peak operational efficiency for cross-functional teams.
                                    </p>
                                </div>
                            </div>

                            {/* Software Developer */}
                            <div className="relative pl-16 group">
                                <div className="absolute left-4 top-2 w-4 h-4 rounded-full bg-neutral-800 border-4 border-black z-10 group-hover:bg-green-500 group-hover:scale-150 transition-all duration-300"></div>
                                <div className="glass-card p-10 rounded-[2rem] hover:border-green-500/30 transition-all duration-500">
                                    <span className="text-gray-500 font-black text-xs uppercase tracking-widest">Independent</span>
                                    <h4 className="text-2xl font-black text-white mt-1 uppercase tracking-tighter">Fullstack Dev</h4>
                                    <p className="text-gray-500 font-bold mb-6">Freelance Engineering</p>
                                    <p className="text-gray-400 text-lg leading-relaxed">
                                        Crafting bespoke mobile and web architectures for diverse clients, focusing on Flutter and React development.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Research Column */}
                    <div className="space-y-12">
                        <div className="flex items-center gap-6 mb-4">
                            <div className="w-14 h-14 bg-white/5 rounded-2xl flex items-center justify-center text-green-500 border border-white/10">
                                <i className="bi bi-mortarboard-fill text-2xl"></i>
                            </div>
                            <h4 className="text-2xl font-black text-white uppercase tracking-tighter">Research</h4>
                        </div>

                        <div className="glass-card p-12 rounded-[3rem] relative overflow-hidden group hover:border-green-500/50 transition-all duration-500 h-full">
                            <div className="absolute top-0 right-0 p-12 text-green-500/5 group-hover:text-green-500/10 transition-colors duration-700">
                                <i className="bi bi-journal-text text-[12rem]"></i>
                            </div>

                            <div className="relative z-10 space-y-8">
                                <div className="inline-flex px-4 py-2 bg-green-500/10 border border-green-500/20 text-green-500 text-xs font-black uppercase tracking-[0.2em] rounded-full">
                                    Published Study
                                </div>
                                <h4 className="text-4xl font-black text-white leading-tight uppercase tracking-tighter">
                                    AMAFA: SMART AGRICULTURE <br /><span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-500 to-white">FRAMEWORK.</span>
                                </h4>
                                <div className="space-y-6">
                                    <p className="text-gray-400 text-xl font-medium">Location: Fort Portal City, Uganda.</p>
                                    <p className="text-gray-500 text-lg leading-relaxed">
                                        Identified critical gaps in agricultural data flow through academic field research. Developed the AMAFA app prototype to transform complex market insights into actionable intelligence for local farmers.
                                    </p>
                                </div>
                                <div className="pt-6">
                                    <a href="#projects" className="text-white font-black hover:text-green-500 transition-colors flex items-center gap-3">
                                        View Case Study <i className="bi bi-arrow-up-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default Experience;
